import { render, staticRenderFns } from "./QuestionJudge.vue?vue&type=template&id=b8fde85a&scoped=true&"
import script from "./QuestionJudge.vue?vue&type=script&lang=js&"
export * from "./QuestionJudge.vue?vue&type=script&lang=js&"
import style0 from "./QuestionJudge.vue?vue&type=style&index=0&id=b8fde85a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fde85a",
  null
  
)

export default component.exports